import { render, staticRenderFns } from "./handlerPlatform.vue?vue&type=template&id=26aa6012&"
import script from "./handlerPlatform.vue?vue&type=script&lang=js&"
export * from "./handlerPlatform.vue?vue&type=script&lang=js&"
import style0 from "./handlerPlatform.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports